/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ThumbsUpOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M7.602 10.875h-4.5a.75.75 0 0 0-.75.75v8.25a.75.75 0 0 0 .75.75h4.5m0-9.75v9.75m0-9.75 3.75-7.5c.8 0 1.56.32 2.12.88s.88 1.32.88 2.12v2.25h5.8c.22 0 .43.04.62.13s.37.22.51.38.24.35.3.55c.07.2.08.42.05.63l-1.12 9c-.05.36-.22.69-.49.93-.28.24-.63.38-.99.38H7.602"
})));
// Fill
const ThumbsUpFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M21.841 8.635c-.21-.24-.47-.43-.76-.56s-.61-.2-.93-.2h-5.05v-1.5c0-.99-.4-1.95-1.1-2.65s-1.66-1.1-2.65-1.1c-.14 0-.28.04-.39.11-.12.08-.22.18-.28.3l-3.55 7.09h-4.03a1.499 1.499 0 0 0-1.5 1.5v8.25a1.499 1.499 0 0 0 1.5 1.5h15.93c.55 0 1.07-.2 1.48-.57.41-.36.68-.86.75-1.4l1.12-9c.04-.32.01-.64-.08-.94-.09-.31-.25-.59-.46-.83zm-18.74 2.99h3.75v8.25h-3.75v-8.25z"
})));
// DuoTone
const ThumbsUpDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M3.102 10.875h4.5v9.75h-4.5a.75.75 0 0 1-.75-.75v-8.25a.75.75 0 0 1 .75-.75z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M7.602 10.875h-4.5a.75.75 0 0 0-.75.75v8.25a.75.75 0 0 0 .75.75h4.5m0-9.75v9.75m0-9.75 3.75-7.5c.8 0 1.56.32 2.12.88s.88 1.32.88 2.12v2.25h5.8c.22 0 .43.04.62.13s.37.22.51.38.24.35.3.55c.07.2.08.42.05.63l-1.12 9c-.05.36-.22.69-.49.93-.28.24-.63.38-.99.38H7.602"
})));
/**
  Icon ThumbsUpIcon in communication group
*/
export const ThumbsUpIcon = createIcon('ThumbsUpIcon', 'thumbs-up', 'communication', ThumbsUpOutline, ThumbsUpFill, ThumbsUpDuotone, "0 0 24 24");